import React, { useState, useContext } from 'react';
import { NavDropdown } from "react-bootstrap";

import { UserContext } from '../../utilities/context'
import { connect } from "react-redux";
import { APIRequest, API_LOGOUT } from "../../api";
import { Notification } from '../notification';
import { authenticate, getUser, isLoggedIn, deauthenticate } from '../../redux/actions/authAction';
import { useHistory } from 'react-router';

const UserInfo = (props) => {
    const user = useContext(UserContext)
    const history = useHistory();

    const logout = () => {
        props.authenticate();
        props.getUser();
        props.isLoggedIn(false);
        new APIRequest.Builder()
            .get()
            .setReqId(API_LOGOUT)
            .setHeader(props?.user?.token)
            .reqURL(`/signout`)
            .response(onResponse)
            .error(onError)
            .build()
            .doRequest();
    }

    const onResponse = (response, reqId) => {
        switch (reqId) {
            case API_LOGOUT:
                props.deauthenticate();
                history.push('/');
                Notification("success", response?.meta?.message);
                break;
            default:
                break;
        }
    };

    const onError = (response, reqId) => {
        switch (reqId) {
            case API_LOGOUT:
                console.log(response, "error");
                break;
            default:
                break;
        }
    };

    return (
        <div>
            <NavDropdown
                title={
                    <div>
                        <div className="d-flex">
                            <div style={{
                                height: "38px",
                                width: "38px",
                                objectFit: "contain",
                            }}>
                                {
                                    user?.profile_pic ?
                                        <img
                                            className="thumbnail-image"
                                            src={user?.profile_pic}
                                            alt="user pic"
                                            height="100%"
                                            width="100%"
                                            style={{ borderRadius: "50%" }}
                                        />
                                        :
                                        <div style={{ padding: '6px' }}><svg fill="currentColor" viewBox="0 0 18 20" xmlns="http://www.w3.org/2000/svg" data-testid="user-icon"><path d="M15.216 13.717L12 11.869C11.823 11.768 11.772 11.607 11.757 11.521C11.742 11.435 11.737 11.267 11.869 11.111L13.18 9.57401C14.031 8.58001 14.5 7.31101 14.5 6.00001V5.50001C14.5 3.98501 13.866 2.52301 12.761 1.48601C11.64 0.435011 10.173 -0.0879888 8.636 0.0110112C5.756 0.198011 3.501 2.68401 3.501 5.67101V6.00001C3.501 7.31101 3.97 8.58001 4.82 9.57401L6.131 11.111C6.264 11.266 6.258 11.434 6.243 11.521C6.228 11.607 6.177 11.768 5.999 11.869L2.786 13.716C1.067 14.692 0 16.526 0 18.501V20H1V18.501C1 16.885 1.874 15.385 3.283 14.584L6.498 12.736C6.886 12.513 7.152 12.132 7.228 11.691C7.304 11.251 7.182 10.802 6.891 10.462L5.579 8.92501C4.883 8.11101 4.499 7.07201 4.499 6.00001V5.67101C4.499 3.21001 6.344 1.16201 8.699 1.00901C9.961 0.928011 11.159 1.35601 12.076 2.21501C12.994 3.07601 13.5 4.24301 13.5 5.50001V6.00001C13.5 7.07201 13.117 8.11101 12.42 8.92501L11.109 10.462C10.819 10.803 10.696 11.251 10.772 11.691C10.849 12.132 11.115 12.513 11.503 12.736L14.721 14.585C16.127 15.384 17.001 16.884 17.001 18.501V20H18.001V18.501C18 16.526 16.932 14.692 15.216 13.717Z"></path></svg></div>
                                }
                            </div>
                            <div className="d-flex align-items-center ml-2" style={{ fontSize: '15px' }}>{user?.name}</div>
                        </div>
                    </div>
                }
                id="basic-nav-dropdown"
                alignRight
                className="p-0 user_dropdown"
            >
                <NavDropdown.Item href="/profile" eventKey="profile">
                    Profile
                </NavDropdown.Item>
                <NavDropdown.Item
                    href="#"
                    onClick={logout}
                    eventKey="logout"
                >
                    Logout
                </NavDropdown.Item>
            </NavDropdown>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};

const mapDispatchToProps = dispatch => ({
    authenticate: () => dispatch(authenticate(null)),
    getUser: () => dispatch(getUser(null)),
    isLoggedIn: (data) => dispatch(isLoggedIn(data)),
    deauthenticate: () => dispatch(deauthenticate())
})

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo);
